export default [
    {
        path: '/SMSOpenApplet',
        component: () => import(/* webpackChunkName:"SMSOpenApplet"*/'@/pages/SMSOpenApplet/index.vue'),
        name: 'SMSOpenApplet',
        meta: {
            title: '打开亚朵小程序',
        },
    },
];
